import { getRangeScheduleAPI } from '../../api/schedule';

/**
 * 「한눈에」(SchedulePage) Smart 범위 조회와 **같은 쿼리 키·같은 데이터 형태**.
 * 키가 같아야 일간 보기 캐시와 목적지 미리보기·저장 후 확인 조회가 서로를 갱신한다.
 * SchedulePage.tsx 의 smartRangeScheduleQuery 와 함께 바꿔야 한다.
 */
export const SMART_RANGE_SCHEDULES_QUERY_KEY = 'getSmartRangeSchedulesAPI';

export const smartRangeSchedulesQueryKey = (centerId: string, startDate: string, endDate: string) =>
    [SMART_RANGE_SCHEDULES_QUERY_KEY, centerId, startDate, endDate] as const;

/** SchedulePage 의 queryFn 과 같다: 200 이 아니면 던지고, schedules 배열만 돌려준다(강사 필터 없음). */
export const fetchSmartRangeSchedules = async (
    centerId: string,
    startDate: string,
    endDate: string,
    authorization: string
): Promise<any[]> => {
    const res = await getRangeScheduleAPI(centerId, startDate, endDate, '', authorization);
    if (res?.status !== 200) {
        throw new Error('일정을 불러오지 못했습니다.');
    }
    return Array.isArray(res?.data?.schedules) ? res.data.schedules : [];
};

/**
 * 저장 후 무효화할 쿼리 묶음 — 기존 수정 폼과 같다.
 * - PT: UpdateOneSchedule.tsx(1:1 수정 onSuccess)
 * - 일반일정: UpdateEtcSchedule.tsx(일반일정 수정 onSuccess)
 */
export const QUICK_MOVE_INVALIDATION_KEYS = {
    private: [
        'getDailyScheduleAPI',
        'getWeeklyScheduleAPI',
        SMART_RANGE_SCHEDULES_QUERY_KEY,
        'getListRangeSchedulesAPI',
        'getMembershipForMemberQuery',
        'getAllMembershipForMemberQuery',
    ],
    general: ['getDailyScheduleAPI', 'getWeeklyScheduleAPI', SMART_RANGE_SCHEDULES_QUERY_KEY, 'getListRangeSchedulesAPI'],
} as const;
